/* eslint-disable class-methods-use-this */
export default class JwtParser {
  parse(token: string | null): any | null {
    if (!token) {
      console.error('Not JWT provided');
      return null;
    }
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
          .join('')
      );

      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error parsing JWT:', error);
      return null;
    }
  }

  isTokenExpired(targetDate: number): boolean {
    const targetDateTime = new Date(targetDate * 1000);
    const fixedDateTime = new Date();
    fixedDateTime.setMinutes(targetDateTime.getMinutes() - 2);
    const currentDate = new Date();

    return fixedDateTime > currentDate;
  }

  getTimeUntilExpire(targetDate: number | null): number {
    if (!targetDate) {
      return 0;
    }
    const targetDateTime = new Date(targetDate * 1000);
    const currentDate = new Date();

    const difference = targetDateTime.getTime() - currentDate.getTime();
    const differenceToMinutes = Math.floor(difference / 1000 / 60);

    return differenceToMinutes;
  }
}
